import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./users.css";
import UserService from "../../services/UserService";
import BasicUsersTable from "../../components/users/BasicUsersTable";
import MessagingUsersTable from "../../components/users/MessagingUsersTable";

const Users = () => {
  const [active, setActive] = useState("basic");
  const [users, setUsers] = useState([]);

  // console.log("users", users);

  const getAllUsers = async () => {
    try {
      const response = await UserService.getUsers();
      if (response) {
        setUsers(response);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <div className="container">
      <div className="overview">
        <div className="title">
          <ion-icon name="people-outline"></ion-icon>
          <span className="text">Users</span>
        </div>
      </div>

      <div className="d-flex">
        <div
          onClick={() => setActive("basic")}
          className={`usersNav ${active == "basic" && "usersNav-active"}`}
        >
          Basic
        </div>
        <div
          onClick={() => setActive("massaging")}
          className={`ms-4 usersNav ${
            active == "massaging" && "usersNav-active"
          }`}
        >
          Messaging
        </div>
      </div>

      {active == "basic" ? (
        <div className="data-table activityTable mt-5">
          <div className="tableStyle mb-5">
            <BasicUsersTable users={users} getAllUsers={getAllUsers} />
          </div>
        </div>
      ) : (
        <div className="data-table activityTable mt-5">
          <div style={{ overflowX: "scroll" }} className="mb-5">
            <div className="tableStyle" style={{ width: "1450px" }}>
              <MessagingUsersTable users={users} getAllUsers={getAllUsers} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;
